











































import {Vue, Component, Watch, Prop} from 'vue-property-decorator'
import {NetworkNamespace} from '@/enums/NetworkNamespace'

@Component({})
export default class ConnectWalletNeon extends Vue {
  @Prop({type: String, required: true})
  networkNamespace!: NetworkNamespace

  base64Uris: Record<NetworkNamespace, string | null> = {
    [NetworkNamespace.n3]: null,
    [NetworkNamespace.x]: null,
  }

  get base64URI() {
    return this.base64Uris[this.networkNamespace]
  }

  returnToChooseWallet() {
    this.$emit('return-page')
  }

  @Watch('$store.state.walletAdapter.n3.uri')
  onN3UriChange(uri: string | null) {
    if (!uri) {
      this.base64Uris[NetworkNamespace.n3] = null
      return
    }

    this.base64Uris[NetworkNamespace.n3] = Buffer.from(uri).toString('base64')
  }

  @Watch('$store.state.walletAdapter.neoX.uri')
  onXUriChange(uri: string | null) {
    if (!uri) {
      this.base64Uris[NetworkNamespace.x] = null
      return
    }

    this.base64Uris[NetworkNamespace.x] = Buffer.from(uri).toString('base64')
  }
}
